import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { twMerge } from '@belong/common';
import { IconClose } from '@belong/icons';
import clsx from 'clsx';
import { ButtonBase } from '../ButtonBase/ButtonBase.js';
import { ModalBase } from '../ModalBase/ModalBase.js';

function CloseButton({
  onClick,
  variant = 'default',
  className
}) {
  return jsx(ButtonBase, {
    id: "modal_close_button",
    className: clsx('block', CLOSE_BUTTON_VARIANT_MAP[variant], className),
    onClick: onClick,
    children: jsx(IconClose, {
      width: 16
    })
  });
}
const solidBorder = 'md:border md:border-solid md:border-dark-gray';
const shadowBorder = 'md:shadow';
const Modal = /*#__PURE__*/React.forwardRef(function ModalComponent({
  isOpen,
  onDismiss,
  size = 'default',
  variant = 'default',
  closeButton = 'content',
  borderStyle = 'solid',
  children,
  overlayClassName,
  contentClassName,
  enableOverflow = false,
  childrenClassName,
  closeButtonClassName,
  ...rest
}, ref) {
  return jsx(ModalBase, {
    overlayClassName: twMerge(MODAL_VARIANT_MAP[variant], size === 'fullScreen' && 'bg-opacity-100 z-fullscreen', overlayClassName),
    contentClassName: twMerge(SIZE_MAP[size], contentClassName),
    ref: ref,
    isOpen: isOpen,
    onDismiss: onDismiss,
    childrenClassName: childrenClassName,
    ...rest,
    children: jsxs("div", {
      className: clsx({
        [`bg-white min-h-screen md:min-h-0 md:rounded`]: size !== 'fullScreen'
      }, {
        'overflow-hidden': !enableOverflow && size !== 'fullScreen'
      }, {
        relative: closeButton === 'content' && size !== 'fullScreen'
      }, {
        [solidBorder]: size !== 'fullScreen' && borderStyle === 'solid'
      }, {
        [shadowBorder]: size !== 'fullScreen' && borderStyle === 'shadow'
      }),
      children: [children, closeButton === 'overlay' || closeButton === 'content' && jsx("div", {
        className: clsx('absolute right-xs top-xs z-20 rounded bg-white p-xs opacity-80', {
          ['md:top-sm md:right-lg']: size === 'fullScreen'
        }),
        children: jsx(CloseButton, {
          variant: variant,
          onClick: onDismiss,
          className: closeButtonClassName
        })
      }), typeof closeButton === 'function' && closeButton({
        onDismiss
      })]
    })
  });
});
Modal.CloseButton = CloseButton;
const CLOSE_BUTTON_VARIANT_MAP = {
  default: 'hover:text-dark-navy',
  light: 'hover:text-dark-navy',
  dark: 'text-white hover:text-green'
};
const MODAL_VARIANT_MAP = {
  default: 'bg-white bg-opacity-95',
  light: 'bg-white bg-opacity-60',
  dark: 'bg-black bg-opacity-90'
};
const SIZE_MAP = {
  default: 'w-full h-full md:w-default-modal',
  small: 'w-full h-full md:w-small-modal',
  large: 'w-full h-full md:w-large-modal-md lg:w-large-modal-lg',
  fullScreen: 'w-full h-full',
  auto: 'w-full md:w-auto'
};

export { Modal };
